// components/MainPage.js

import React from "react";
import Navbar from "../components/navbar";
import HeroSection from "../components/HeroSection";
import HotmessBrandSection from "../components/HotmessBrandSection";
import Schedule from "../components/Schedule";
import Podcasts from "../components/podcasts";
import HotmessHero from "../components/HotmessHero";
import ShopifyProducts from "../components/ShopifyProducts";
import HotmessBanner from "../components/HotmessBanner";

export default function MainPage() {
  return (
    <div>
      <Navbar />
      <HeroSection />
      <ShopifyProducts/>
      <div id="hotmess-banner">
        <HotmessBanner/>
      </div>
      <HotmessBrandSection />
      <Schedule />
      <Podcasts />
      <HotmessHero/>  
    </div>
  );
}